/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ totalWords: NonNullable<unknown> }} Event_Metrics_Words_TitleInputs */

const en_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} Total Words`)
};

const fr_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} Mots totaux`)
};

const de_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} Gesamtwörter`)
};

const it_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} Parole totali`)
};

const ru_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} Всего слов`)
};

const es_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} Total de palabras`)
};

const zh_cn2_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} 总字数`)
};

const ja_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} 合計単語数`)
};

const hi_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} कुल शब्द`)
};

const pt_pt2_event_metrics_words_title = /** @type {(inputs: Event_Metrics_Words_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.totalWords} Total de palavras`)
};

/**
* | output |
* | --- |
* | "{totalWords} Total Words" |
*
* @param {Event_Metrics_Words_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_words_title = /** @type {((inputs: Event_Metrics_Words_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Words_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_words_title(inputs)
	if (locale === "de") return de_event_metrics_words_title(inputs)
	if (locale === "it") return it_event_metrics_words_title(inputs)
	if (locale === "ru") return ru_event_metrics_words_title(inputs)
	if (locale === "es") return es_event_metrics_words_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_words_title(inputs)
	if (locale === "ja") return ja_event_metrics_words_title(inputs)
	if (locale === "hi") return hi_event_metrics_words_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_words_title(inputs)
	return en_event_metrics_words_title(inputs)
});